import { render, staticRenderFns } from "./BackComNews.vue?vue&type=template&id=52201f93&scoped=true"
import script from "./BackComNews.vue?vue&type=script&lang=js"
export * from "./BackComNews.vue?vue&type=script&lang=js"
import style0 from "./BackComNews.vue?vue&type=style&index=0&id=52201f93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52201f93",
  null
  
)

export default component.exports